import {FilteredProvincesValueObject} from './FilteredProvincesValueObject.js'
import {UnseenSavedSearchMatchesValueObject} from './UnseenSavedSearchMatchesValueObject.js'
import {UserAlertIdValueObject} from './UserAlertIdValueObject.js'
import {UserAlertsListValueObject} from './UserAlertsListValueObject.js'

export class UserAlertsListValueObjectFactory {
  static userAlertsListValueObject = ({userAlerts}) => new UserAlertsListValueObject({userAlerts})

  static userAlertIdValueObject = ({alertId}) => new UserAlertIdValueObject({alertId})

  static filteredProvincesValueObject = ({filteredProvinces}) => new FilteredProvincesValueObject({filteredProvinces})

  static unseenSavedSearchMatchesValueObject = ({matchCounters}) =>
    new UnseenSavedSearchMatchesValueObject({matchCounters})
}
